import axios from "../axios";

const DIGEST_SETTINGS_PATH = "/hse/digest_settings";

function unwrap(response) {
  return response.data?.data || response.data;
}

export async function fetchHseDigestSettings() {
  return axios.get(DIGEST_SETTINGS_PATH).then(unwrap);
}

export async function updateHseDigestSettings(payload) {
  return axios
    .put(DIGEST_SETTINGS_PATH, {
      digest_settings: payload,
    })
    .then(unwrap);
}
